import { ParamConstants, isEmpty, operatorConstants } from "./Constants";

export interface filterValue {
  fieldValue: string;
  operator: string;
  value: string | string[];
}

interface hashValue {
  field: string;
  value: string;
}

interface propTypes {
  hashData?: hashValue;
  searchData?: string[];
  filterData?: filterValue[] | {};
}

//{{base_url}}/receipt?memberId=edisontan315@gmail.com&search=recipNUmber&filters=amount_bpo:eq:27.00|receipt_status:eq:accept

///const params= {hashData:hashValues,searchData:searchValue,filterData:filtervalues }
/// cal this getHashURL(param)

const notToConvertToDate = [
  "merchant",
  "merchantId",
  "merchant_ext_id",
  "merchant_id",
  "status",
  "utilized",
];
export const getHashURL = (params: propTypes) => {
  const { hashData, searchData, filterData } = params;
  const urlValues = [];
  if (!isEmpty(hashData)) urlValues.push(getHashParam(hashData));
  if (isNonEmptyObj(searchData)) urlValues.push(getSearchParam(searchData));
  if (isNonEmptyObj(filterData)) urlValues.push(getFilterParam(filterData));

  const url = urlValues.join(ParamConstants.paramSeparator);
  return url;
};

export const getDateRange = (date: any) => {
  const utcDate = new Date(new Date(new Date(+date)).toUTCString());
  // Set time to 00:00:00
  utcDate.setHours(0, 0, 0, 0);
  const startOfDayEpoch = utcDate.getTime();
  // Set time to 23:59:59
  utcDate.setHours(23, 59, 59, 999);
  const endOfDayEpoch = utcDate.getTime();
  return `${startOfDayEpoch},${endOfDayEpoch}`;
};
function isDateOrEpoch(value: any) {
  return (
    value instanceof Date ||
    (typeof value === "number" && !isNaN(value) && value >= 0)
  );
}

const getHashParam = (hashValue: any) => {
  const { field, value } = hashValue;
  return `${field}=${value}`;
};

const getSearchParam = (searchValue: any) => {
  const arrayData = searchValue.map((item: any) => item);
  const dataURL = `${ParamConstants.search}${arrayData.join(
    ParamConstants.paramIncluder
  )}`;
  return dataURL;
};
const getFilterParam = (filterParam: filterValue[] | any) => {
  const filteredArr = filterParam?.filter(
    (obj: any) => Object.keys(obj).length > 0
  );

  const arrayData = filteredArr?.map((item: filterValue) => getParam(item));
  const dataValue = `${ParamConstants.filter}${arrayData.join(
    ParamConstants.paramIncluder
  )}`;

  return dataValue;
};
const getParam = (data: filterValue) => {
  let { fieldValue, operator, value } = data;

  if (
    notToConvertToDate.includes(fieldValue) ||
    operator === operatorConstants.between
  ) {
    return `${fieldValue}:${operator}:${value}`;
  }
  let dates;
  // if (typeof value === "string" && !isNaN(+value)) {
  //   value = +value;
  // }
  if (isDateOrEpoch(+value) && !Array.isArray(value)) {
    operator = "between";
    dates = getDateRange(value);
  } else {
    dates = Array.isArray(value) ? value.join(",") : value;
  }
  return dates && `${fieldValue}:${operator}:${dates}`;
};

const isNonEmptyObj = (checkObj: any) => {
  if (Array.isArray(checkObj)) return checkObj.length > 0;
  return checkObj && Object.keys(checkObj).length > 0;
};
